import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import { Table } from '../../../../common/table'
import EventEmitter, {
  SHOW_POPUP_FOLLOW_ALERT,
} from '../../../../helpers/EventEmitter'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import {
  selectCompanyAlerts,
  selectCompanyAlertsById,
  selectLoading,
} from '../../store/slice'
import { getCompanyAlerts } from '../../store/thunk'
import useDidUpdateEffect from './../../../../common/hooks/useDidUpdateEffect'
import { AlertTabs } from './AlertTabs'
import { TableCell } from './TableCell'
import { ALERT_TYPES, COLUMN_IDS, SENTIMENT_TYPE_ID } from './helper'
import classes from './index.module.scss'

export const CompanyAlerts = () => {
  const dispatch = useDispatch()

  const { organizationId, isFollowed } = useSelector(selectCompanyInfo)
  const data = useSelector(selectCompanyAlerts())
  const isLoading = useSelector(selectLoading('companyAlerts'))

  const [alertType, setAlertType] = useState(ALERT_TYPES.TOTAL)

  useDidUpdateEffect(() => {
    if (!organizationId) return
    const params = {
      OrganizationId: organizationId,
      Page: 1,
      PageSize: 5,
    }
    params.ReadStatus = alertType === ALERT_TYPES.UNREAD ? false : null
    params.SentimentId =
      alertType === ALERT_TYPES.NEGATIVE ? [SENTIMENT_TYPE_ID.NEGATIVE] : null
    dispatch(getCompanyAlerts(params))
  }, [alertType, organizationId])

  const schema = Object.keys(COLUMN_IDS).map((key) => {
    const colId = COLUMN_IDS[key]
    const title = 'companySummary.companyAlerts.' + key

    return {
      colId,
      title,
      isI18n: true,
      render: (data, { rowId, rowIndex }) => (
        <TableCell
          data={data}
          colId={colId}
          rowId={rowId}
          rowIndex={rowIndex}
        />
      ),
    }
  })

  const onRowClick = (rowId) => {
    window.open(`/alerts/${rowId}`, '_blank')
  }

  const openFollowAlert = () => {
    EventEmitter.dispatch(SHOW_POPUP_FOLLOW_ALERT, true)
  }

  return (
    <Element className={classes.container}>
      <Element className="flexColumn h100">
        <AlertTabs alertType={alertType} setAlertType={setAlertType} />
        <Element className="flex1 minH0 positionRelative">
          {isLoading ? (
            <Loading />
          ) : !data || !Object.keys(data).length ? (
            <Notification
              isI18n={!!isFollowed}
              value={
                !!isFollowed ? (
                  'companySummary.companyAlerts.NO_ALERT_TO_DISPLAY'
                ) : (
                  <div className="textCenter">
                    <Translate value="companySummary.companyAlerts.USER_DISABLE_ALERT_1" />
                    <br />
                    <Translate value="companySummary.companyAlerts.USER_DISABLE_ALERT_2" />
                    &nbsp;
                    <Element
                      elementName="span"
                      className="cursorPointer"
                      style={{ color: '#2C73E8' }}
                      onClick={openFollowAlert}
                    >
                      <Translate value="companySummary.companyAlerts.CLICK_HERE" />
                    </Element>
                    &nbsp;
                    <Translate value="companySummary.companyAlerts.USER_DISABLE_ALERT_3" />
                  </div>
                )
              }
            />
          ) : (
            <Table
              ids={data.map((i) => i.recordId)}
              getDataFromRedux={selectCompanyAlertsById}
              schema={schema}
              onRowClick={onRowClick}
            />
          )}
        </Element>
      </Element>
    </Element>
  )
}
